// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/badge/style/index.less
// module id = 1764
// module chunks = 1